import { useTranslation } from "react-i18next";
import { getErrorMessages } from "../../../Utils";

const InputError = ({ id, error, onClear }) => {
  const { t } = useTranslation();

  // Translated inside, so the line prefix on a backend validation error
  // survives — a prefixed sentence is no longer a key.
  const errors = getErrorMessages(error, t);

  if (!errors.length) return null;

  return (
    <div className="flex items-start justify-between mt-1">
      <ul id={`${id}-error`} className="space-y-1">
        {errors.map((msg, i) => (
          <li key={i} className="text-sm text-red-600">
            {msg}
          </li>
        ))}
      </ul>
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          {t("common.clear")}
        </button>
      )}
    </div>
  );
};

export default InputError;
